// === Floating Icons Parallax ===
  (function() {
    const SPEED = 0.08;

    const icons = document.querySelectorAll('[class*="ai-floating-icon-"]');
    if (!icons.length) return;

    const rates = Array.from(icons).map(function() {
      return 0.5 + Math.random() * 0.5;
    });

    // Store each icon's original rotation
    var originalRotations = Array.from(icons).map(function(icon) {
      var match = icon.style.transform.match(/rotate\(([^)]+)\)/);
      return match ? match[1] : '0deg';
    });

    var lastScrollY = window.scrollY;
    var offsets = Array.from(icons).map(function() { return 0; });

    var ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var delta = window.scrollY - lastScrollY;
          lastScrollY = window.scrollY;

          icons.forEach(function(icon, i) {
            offsets[i] += delta * rates[i] * SPEED;
            offsets[i] = Math.max(-50, Math.min(50, offsets[i]));
            icon.style.transform = 'translate(-50%, calc(-50% + ' + offsets[i] + 'px)) rotate(' +
  originalRotations[i] + ')';
          });
          ticking = false;
        });
        ticking = true;
      }
    });
  })();